import { MessageService } from '../../../../services/message-service/message.service';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Futtermittellieferant } from '../lieferant';
import { StammdatenService } from '../../stammdaten.service';

@Component({
    selector: 'kiene-lieferant-anlegen-dialog',
    templateUrl: './lieferant-anlegen-dialog.component.html',
    styleUrls: ['./lieferant-anlegen-dialog.component.scss'],
})
export class LieferantAnlegenDialogComponent implements OnInit {
    nameCtrl = new FormControl(undefined, [Validators.required]);
    strasseCtrl = new FormControl();
    plzCtrl = new FormControl();
    ortCtrl = new FormControl();
    emailCtrl = new FormControl(undefined, [Validators.email, Validators.required]);
    qsidCtrl = new FormControl();
    telefonCtrl = new FormControl();
    mobilCtrl = new FormControl();
    faxCtrl = new FormControl();

    constructor(
        public dialogRef: MatDialogRef<LieferantAnlegenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public lieferant: Futtermittellieferant,
        private messageService: MessageService,
        private stammdatenService: StammdatenService,
    ) {}

    ngOnInit(): void {
        this.nameCtrl.setValue(this.lieferant?.bezeichnung);
        this.strasseCtrl.setValue(this.lieferant?.strasse);
        this.plzCtrl.setValue(this.lieferant?.plz);
        this.ortCtrl.setValue(this.lieferant?.ort);
        this.emailCtrl.setValue(this.lieferant?.email);
        this.telefonCtrl.setValue(this.lieferant?.telefon);
        this.qsidCtrl.setValue(this.lieferant?.qs_id);
        this.mobilCtrl.setValue(this.lieferant?.mobil);
        this.faxCtrl.setValue(this.lieferant?.fax);
    }

    anlegen() {
        const lieferant = new Futtermittellieferant();
        lieferant.futtermittellieferant_id = this.lieferant?.futtermittellieferant_id;
        lieferant.bezeichnung = this.nameCtrl.value;
        lieferant.strasse = this.strasseCtrl.value;
        lieferant.plz = this.plzCtrl.value;
        lieferant.ort = this.ortCtrl.value;
        lieferant.email = this.emailCtrl.value;
        lieferant.telefon = this.telefonCtrl.value;
        lieferant.qs_id = this.qsidCtrl.value;
        lieferant.mobil = this.mobilCtrl.value;
        lieferant.fax = this.faxCtrl.value;

        this.stammdatenService.createOrUpdateFuttermittellieferant(lieferant).subscribe({
            next: (response: Futtermittellieferant) => {
                this.dialogRef.close(response);
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Anlegen eines Lieferanten!', err);
            },
        });
    }
}
